import React from 'react';
import OrderCard from './OrderCard';

function PortfolioList({ activeTab, orders, fetchData, onCardClick, error }) {

    if (!orders || orders.length === 0) {
        return (
            <div className="text-center text-gray-500 mt-4">
                <div className="flex flex-col h-full">
                    <img
                        className="mb-5 max-w-full h-auto align-top"
                        src={`${process.env.PUBLIC_URL}/7562233.webp`}
                        alt="No orders"
                    />
                </div>
                No orders found
            </div>
        );
    }

    return (
        <div className="mb-20">
            {orders.map((item, index) => (
                <OrderCard
                    key={index}
                    activeTab={activeTab}
                    order={item}
                    fetchData={fetchData}
                    onClick={() => onCardClick(item, fetchData)}
                />
            ))}
        </div>
    );
}

export default PortfolioList;